import { BookOpen, ArrowLeft } from '@phosphor-icons/react'
import { useNavigate } from 'react-router-dom'

export function TermsOfService() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-background py-10 px-4">
      <div className="max-w-3xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-muted-foreground hover:text-foreground text-sm mb-8 transition-colors"
        >
          <ArrowLeft size={16} />
          Voltar
        </button>

        <div className="flex items-center gap-3 mb-8">
          <BookOpen size={28} className="text-action-primary" />
          <h1 className="text-3xl font-black uppercase italic tracking-tight text-foreground">EDURPG.IA</h1>
        </div>

        <h2 className="text-2xl font-black text-foreground mb-2">Termos de Serviço</h2>
        <p className="text-muted-foreground text-sm mb-8">Última atualização: março de 2026</p>

        <div className="prose prose-sm max-w-none space-y-space-6 text-foreground">

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">1. Aceitação dos Termos</h3>
            <p className="text-muted-foreground leading-relaxed">
              Ao criar uma conta ou usar a plataforma EDURPG.IA disponível em{' '}
              <a href="https://edurpg.ia.br" className="text-action-primary hover:underline">
                edurpg.ia.br
              </a>
              , você concorda com estes Termos de Serviço. Se não concordar com alguma cláusula, não utilize
              a plataforma.
            </p>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">2. Descrição do Serviço</h3>
            <p className="text-muted-foreground leading-relaxed">
              O EDURPG.IA é uma plataforma educacional de RPG de mesa com suporte a inteligência artificial,
              destinada a professores e estudantes. Oferecemos funcionalidades como criação de campanhas,
              gerenciamento de personagens, sistema de combate, chat em tempo real e módulos de jogo solo.
            </p>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">3. Elegibilidade e Contas</h3>
            <ul className="list-disc pl-6 space-y-space-2 text-muted-foreground">
              <li>Você deve ter pelo menos 13 anos para usar esta plataforma.</li>
              <li>Você é responsável pela segurança e confidencialidade das suas credenciais de acesso.</li>
              <li>É proibido criar múltiplas contas para contornar restrições ou banimentos.</li>
              <li>Você deve fornecer informações verdadeiras no cadastro.</li>
            </ul>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">4. Uso Aceitável</h3>
            <p className="text-muted-foreground leading-relaxed">Ao usar nossa plataforma, você concorda em NÃO:</p>
            <ul className="list-disc pl-6 space-y-space-2 text-muted-foreground">
              <li>Publicar conteúdo ilegal, ofensivo, discriminatório ou que viole direitos de terceiros.</li>
              <li>Tentar aceder a sistemas ou dados de outros usuários sem autorização.</li>
              <li>Usar a plataforma para spam ou atividades comerciais não autorizadas.</li>
              <li>Realizar engenharia reversa, decompilar ou interferir no funcionamento do serviço.</li>
              <li>Usar bots, scripts ou meios automatizados sem autorização prévia.</li>
            </ul>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">5. Conteúdo do Usuário</h3>
            <p className="text-muted-foreground leading-relaxed">
              Você mantém a propriedade do conteúdo que cria na plataforma (personagens, campanhas, mensagens).
              Ao submeter conteúdo, concede ao EDURPG.IA uma licença limitada, não exclusiva, para armazenar e
              exibir esse conteúdo no contexto do serviço. Você é responsável pelo conteúdo que publica.
            </p>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">6. Propriedade Intelectual</h3>
            <p className="text-muted-foreground leading-relaxed">
              A plataforma EDURPG.IA, sua interface, código-fonte, logotipo e materiais educacionais originais
              são protegidos por direitos autorais. Não é permitida a reprodução ou distribuição sem
              autorização expressa.
            </p>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">7. Disponibilidade e Modificações</h3>
            <p className="text-muted-foreground leading-relaxed">
              O EDURPG.IA é fornecido "como está". Reservamo-nos o direito de modificar, suspender ou
              encerrar funcionalidades sem aviso prévio. Faremos esforços razoáveis para comunicar
              mudanças relevantes com antecedência.
            </p>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">8. Limitação de Responsabilidade</h3>
            <p className="text-muted-foreground leading-relaxed">
              Na extensão permitida por lei, o EDURPG.IA não se responsabiliza por danos indiretos, incidentais
              ou consequenciais decorrentes do uso ou impossibilidade de uso da plataforma.
            </p>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">9. Encerramento de Conta</h3>
            <p className="text-muted-foreground leading-relaxed">
              Você pode solicitar a exclusão da sua conta a qualquer momento. Reservamo-nos o direito de
              suspender ou encerrar contas que violem estes termos, sem aviso prévio.
            </p>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">10. Lei Aplicável</h3>
            <p className="text-muted-foreground leading-relaxed">
              Estes termos são regidos pela legislação brasileira. Eventuais disputas serão resolvidas no
              foro da comarca competente no Brasil.
            </p>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">11. Contato</h3>
            <p className="text-muted-foreground leading-relaxed">
              Para dúvidas sobre estes termos ou solicitações gerais:
              <br />
              <strong className="text-foreground">E-mail:</strong>{' '}
              <a href="mailto:paulovicente.ifba@gmail.com" className="text-action-primary hover:underline">
                paulovicente.ifba@gmail.com
              </a>
            </p>
          </section>

        </div>

        <p className="mt-10 text-xs text-muted-foreground text-center">
          © {new Date().getFullYear()} EDURPG.IA · Plataforma Educacional de RPG de Mesa
        </p>
      </div>
    </div>
  )
}
